import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";

/**
 * A comment belongs to the file, not to the page, so the editor shows where it stands and no more: a
 * thin line across for a comment of its own, a bar inside a line, and the words on hover. It is
 * edited in the source; a mark is there so that it is not deleted along with a neighbour unseen.
 */
const SourceCommentView = ({ node }: NodeViewProps) => {
	const isInline = node.type.isInline;
	const words = (node.attrs.text as string).trim();

	return (
		<NodeViewWrapper as={isInline ? "span" : "div"} data-qa="qa-source-comment">
			<Tooltip>
				<TooltipTrigger asChild>
					{isInline ? (
						<span className="inline-block px-[0.2em] align-middle">
							<span className="block h-[1em] border-l-2 border-secondary-border" />
						</span>
					) : (
						<div className="py-[0.4em]">
							<div className="border-t border-dashed border-secondary-border" />
						</div>
					)}
				</TooltipTrigger>
				{words && <TooltipContent className="max-w-[40ch] whitespace-pre-wrap">{words}</TooltipContent>}
			</Tooltip>
		</NodeViewWrapper>
	);
};

export default SourceCommentView;
